
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanTShape as ObiBuoyCanTShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-t-shape.js';
 
 
 

 
 export const ObiBuoyCanTShape = createComponent({
   react: React,
   tagName: 'obi-buoy-can-t-shape',
   elementClass: ObiBuoyCanTShapeElement,
   events: {
     
   }
  });
 
 